<template>
  <div>
    <search-bar @search="onSearch" name="cu_name" placeholder="输入客户名称进行查找" ref="searchBar" />
    <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <div
        class="weui-cell weui-cell_access"
        v-for="(item, index) in items"
        :key="index"
        @click="gotoView(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.cu_name}}</p>
          <!-- <p class="list-item-muted">{{item.ve_buyername}}</p> -->
        </div>
        <div class="weui-cell__ft">
          <p>{{item.cm_yearmonth}}</p>
          <!-- <p class="list-item-muted" v-format="'#,##0.00'">{{item.vm_end}}</p> -->
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}笔</label>
      <!-- <em class="list-footer__value">
        合计：
        <span v-format="'#,##0.00'">{{getTotal()}}</span>元
      </em> -->
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/ledger/gs_month/list",
      params: {
        mode: "DETAIL",
        number: 1,
        size: 99999,
        calculateFields: JSON.stringify([
          {"field":"cm_begin_gs","operation":"sum"},
          {"field":"cm_add_gs","operation":"sum"},
          {"field":"cm_reduce_gs","operation":"sum"},
          {"field":"cm_end_gs","operation":"sum"}
        ]),
        page: 1,
        start: 0,
        limit: 99999
      },
      filters: [
        {
          type: "period",
          name: "cm_yearmonth"
        }
      ],
    };
  },
  mounted() {
    this.doSearch()
  },  
  methods: {
    gotoView(item) {
      this.$router.push({
        name: "MoneySendoutgoodsdetailReportDetail",
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
    // getTotal() {
    //   var me = this,
    //     items = me.items,
    //     total = 0
    //   items.forEach((item) => {
    //     total += item.vm_end;
    //   });
    //   return total;
    // }
  },
};
</script>